import _ from 'lodash'
import { Fragment } from 'react'
import Container from 'react-bootstrap/Container'
import { useIntl } from 'react-intl'

import { ALLOWED_PAYMENTS } from '../../../../components/Basket/constants'
import Typography from '../../../../components/Typography/Typography'
import InfoWindow from '../../../../components/Windows/InfoWindow/InfoWindow'
import PaymentButton from './components/PaymentButton/PaymentButton'

import './PaymentMethod.scss'

const PaymentMethod = ({
    goPayVariant,
    setGoPayVariant,
    selectedPayment,
    setPaymentMethod,
    allowedPayments,
    note,
    loading,
}) => {
    const intl = useIntl()

    if (_.isEmpty(allowedPayments)) return null

    const allowPaymentsAdditional = []
    if (allowedPayments && allowedPayments.includes('Gopay')) {
        allowPaymentsAdditional.push('Card', 'BankAccount', 'GooglePay', 'ApplePay')
    }

    return (
        <Container fluid className="payment-method d-flex flex-column">
            <Typography variant={'h2'}>{intl.formatMessage({ id: 'orderSummary.paymentMethod' })}</Typography>
            {note && selectedPayment !== ALLOWED_PAYMENTS.CASH && (
                <InfoWindow
                    color={'white'}
                    element={
                        <Typography variant={'p'} color={'darkerPrimary'} dangerouslySetInnerHTML={{ __html: note }} />
                    }
                />
            )}

            <div className="payment-method--row">
                {allowPaymentsAdditional.map((payment) => (
                    <Fragment key={payment}>
                        {
                            <PaymentButton
                                payment={'Gopay' + payment}
                                selected={selectedPayment + goPayVariant}
                                onClick={() => {
                                    setPaymentMethod('Gopay')
                                    setGoPayVariant(payment)
                                }}
                                disabled={loading}
                            />
                        }
                    </Fragment>
                ))}
                {allowedPayments?.map((payment) => (
                    <Fragment key={payment}>
                        {payment !== ALLOWED_PAYMENTS.CASH &&
                            payment !== ALLOWED_PAYMENTS.GOPAY &&
                            payment !== ALLOWED_PAYMENTS.GP_WEBPAY && (
                                <PaymentButton
                                    payment={payment}
                                    selected={selectedPayment}
                                    onClick={() => {
                                        setPaymentMethod(payment)
                                        setGoPayVariant(null)
                                    }}
                                    disabled={loading}
                                />
                            )}
                    </Fragment>
                ))}
            </div>
        </Container>
    )
}

export default PaymentMethod
